import { breakpoints } from "styles/grid";
import styled, { css } from "styled-components";

const List = styled("ul").attrs(
	({ noPad, noPadBottom, padTopCard, noFullData, ...props }) => ({
		role: "menubar",
		...props,
	})
)`
	display: flex;
	flex-wrap: wrap;
	list-style: none;
	margin: 0;
	padding: 0;

	${({ justifyBetween }) => {
		return (
			justifyBetween &&
			css`
				justify-content: space-between;
			`
		);
	}}

	${({ noPad }) => {
		return (
			!noPad &&
			css`
				padding: 0.5rem 0;
			`
		);
	}}

	${({ padTopCard }) => {
		return (
			padTopCard &&
			css`
				padding-top: 0.25rem;
			`
		);
	}}

	${({ noPadBottom }) => {
		return (
			noPadBottom &&
			css`
				padding-bottom: 0;
			`
		);
	}}

${({ noFullData }) => {
		return (
			noFullData &&
			css`
				display: flex;
				justify-content: flex-end;
				height: 64px;
			`
		);
	}}

	white-space: normal;

	a {
		display: flex;
		flex-direction: column;
	}

	@media (max-width: ${breakpoints.phone - 1}px) {
		flex: 1;
	}
`;

export default List;
